export default [
	{
		path: '/warehouse/list',
		name: 'warehouse-list',
		meta: { title: '仓库管理', hidden: false },
		component: () => import('@/views/basic/WarehouseList.vue')
	},
    {
        path:'/store/list',
        name:'store-list',
        meta: { title: '门店管理', hidden: false },
        component: () => import('@/views/basic/StoreList.vue')
    },
    {
        path:'/storage/list',
        name:'storage-list',
        meta: { title: '库位管理', hidden: false },
        component: () => import('@/views/basic/StorageList.vue')
    },
    {
        path:'/product/list',
        name:'product-list',
        meta: { title: '商品管理', hidden: false },
        component: () => import('@/views/basic/ProductList.vue')
    },
    {
        path:'/supplier/list',
        name:'supplier-list',
        meta: { title: '供应商管理', hidden: false },
        component: () => import('@/views/basic/SupplierList.vue')
    }
]